<template>
  <div
    class="dialog-bg"
    v-if="show"
    :style="{background: modal? 'rgba(0, 0, 0, .5)' : 'transparent'}">
      <div class="dialog-close" @click="cancelShow" v-if="modal">
        <img src="../../assets/img/closeWhite.png" @click="cancelShow" alt="">
      </div>
    <div class="dialog-content" @click.stop :class="{'dialog-content--modal': !modal}">
      <div v-if="title !== ''"
        class="dialog-content-top"
        :class="{'dialog-content-top--modal' : !modal}">
        <div class="dialog-content__title">{{  title  }}</div>
        <img v-if="!modal" src="../../assets/img/closeWhite.png" @click="cancelShow" alt="">
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dialog",
  props: {
    /**控制弹窗显示 */
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    /**弹窗标题 */
    title: {
      type: String,
      default: ''
    },
    /**是否显示蒙层 */
    modal: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancelShow(){
      this.$emit('cancel', false)
    },
  }
}
</script>

<style scoped lang="scss">
.dialog{
  &-bg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    min-width: 1980px;
    height: 100%;
    min-height: 100vh;
    z-index: 10;
    &::-webkit-scrollbar{
      width: 0;
      height: 0;
    }
  }
  &-close{
    position: fixed;
    right: 0;
    height: 40px;
    width: 40px;
    padding: 5px 5px 19px 15px;
    border-radius: 0 0 0 40px;
    background-color: #00a0c7;
    &:hover{
      cursor: pointer;
      opacity: .8;
    }
    img{
      width: 20px;
    }
  }
  &-content{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 20px 10px;
    max-height: 90vh;
    overflow-y: scroll;
    overflow-x: visible;
    scrollbar-width: none;
    border-radius: 5px;
    &-top{
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: black;
      font-size: 18px;
      height: 30px;
      line-height: 30px;
      border-radius: 5px 5px 0 0 ;
      &--modal{
        background: #00a0c7;
        color: white;
        font-size: 14px;
      }
      img{
        width: 15px;
        height: 15px;
        margin-right: 5px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
    &__title{
      padding: 0 20px;
    }
    &--modal{
      padding: 0;
      box-shadow: 2px 4px 15px 5px #bfbfbf;
    }
  }
}
</style>
